import React from 'react'

import Header from '../components/Header';
import About from '../components/About';
import Features from '../components/Features';
import Stats from '../components/Stats';
import Partners from '../components/Partners';
import Reviews from '../components/Reviews';
import Apply from '../components/Apply';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export default function Home() {
  const { t, i18n } = useTranslation();
  // The ?lang=en variant is advertised via hreflang, so its title, description
  // and og:locale have to be English too — a Russian title on an English page
  // is the mismatch that made the hreflang pair look like duplicates.
  const lang = (i18n.resolvedLanguage || 'ru').split('-')[0];

  const title = t('home.metaTitle', 'Mileage Riot — Виртуальная транспортная компания ETS2 & ATS');
  const description = t(
    'home.metaDescription',
    'Mileage Riot — виртуальная транспортная компания для ETS2 и ATS. Конвои, экономика, рейтинги и сообщество дальнобойщиков.'
  );

  return (
    <>
      <Helmet>
        <html lang={lang} />
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href="https://mileageriot.com/" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content="https://mileageriot.com/" />
        <meta property="og:locale" content={lang === 'en' ? 'en_US' : 'ru_RU'} />
      </Helmet>
      <div className=''>

        <Header />
        <About />
        <Features />
        <Stats />
        <Partners />
        <Reviews />
        <Apply />
      </div>
    </>
  )
}
